import React from 'react';
import ReactDOM from 'react-dom/client';
import './base.css'; // ONLY global styles - NO component classes
import App from './App';
import { ThemeProvider, ThemeManager } from './theme';
import { ErrorBoundary } from './components/ErrorBoundary';
import { injectAnimations } from './theme/animations';
import { register } from './registerServiceWorker';

// Initialize theme manager and animations on app start
ThemeManager.getInstance();
injectAnimations();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary level="page">
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Enable service worker for PWA functionality
register();